import { defineStore } from "pinia";
import { ref } from "vue";
import * as CmsService from "../services/cms.service";
import {useLocalization} from "@/locales/localization";

export const usePromotionStore = defineStore('bannerPromotionStore', () => {
    const promotionImage = ref(null);
    const loadingPromotion = ref(false);
    const { currentLocale } = useLocalization();

    async function fetchPromotionImage(force = false) {
        if (promotionImage.value && !force) return;

        loadingPromotion.value = true;
        try {
            const response = await CmsService.getPromotionImage(currentLocale.value);
            if (!Array.isArray(response.data) || response.data.length === 0 || !response.data[0].imageSet) {
                console.warn("Promotion image API returned empty data:", response.data);
                promotionImage.value = null;
                return;
            }
            const image = response.data[0].imageSet["full"];
            promotionImage.value = image;
        } catch (error) {
            console.error("Error fetching promotion image:", error);
            promotionImage.value = null;
        } finally {
            loadingPromotion.value = false;
        }
    }

    return {
        promotionImage,
        loadingPromotion,
        fetchPromotionImage
    };
});